import React from 'react';
import { Card, Button, Container, Row, Col } from 'react-bootstrap';

const Pos = () => {
  const products = [
    {
      id: 1,
      title: 'Mouse',
      price: '$500',
      image: 'https://images.unsplash.com/photo-1623425484828-7eccb29713a7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fG1vdXNlJTIwdGVjaG5vbG9naWNhbHxlbnwwfHwwfHx8MA%3D%3D'
    },
    {
      id: 2,
      title: 'Iphone',
      price: '$1000',
      image: 'https://images.unsplash.com/photo-1726587912121-ea21fcc57ff8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aXBob25lJTIwMTZ8ZW58MHx8MHx8fDA%3D'
    },
    {
      id: 3,
      title: 'MacBook',
      price: '$2000',
      image: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8bWFjYm9va3xlbnwwfHwwfHx8MA%3D%3D'
    },
     {
      id: 1,
      title: 'Mouse',
      price: '$500',
      image: 'https://images.unsplash.com/photo-1623425484828-7eccb29713a7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fG1vdXNlJTIwdGVjaG5vbG9naWNhbHxlbnwwfHwwfHx8MA%3D%3D'
    },
    {
      id: 2,
      title: 'Iphone',
      price: '$1000',
      image: 'https://images.unsplash.com/photo-1726587912121-ea21fcc57ff8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aXBob25lJTIwMTZ8ZW58MHx8MHx8fDA%3D'
    },
    {
      id: 3,
      title: 'MacBook',
      price: '$2000',
      image: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8bWFjYm9va3xlbnwwfHwwfHx8MA%3D%3D'
    }
  ];

  return (
    <Container className="my-4">
      <h2 className="text-center mb-4">🛍️ Featured Products</h2>
      <Row>
        {products.map((product) => (
          <Col md={4} key={product.id}>
            <Card className="mb-4 shadow-sm">
              <Card.Img
                variant="top"
                src={product.image}
                alt={product.title}
                style={{ height: '250px', objectFit: 'cover' }}
              />
              <Card.Body className="text-center">
                <Card.Title>{product.title}</Card.Title>
                <Card.Text>{product.price}</Card.Text>
                <Button variant="primary">Add to Cart</Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Pos;
